import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';

import Button from '../common/inputs/button';

const ChangePeriodStateButton = props => {
  const {
    loadingChangePeriodState,
    handleChangePeriodState,
    buttonLabelText,
  } = props;
  return (
    <div className="calculation_section change_period_state_wrapper">
      <h3>{<FormattedMessage id="periodAdmin.changePeriodStateTitle"/>}</h3>
      <Button
        disabled={loadingChangePeriodState}
        loading={loadingChangePeriodState}
        onClick={handleChangePeriodState}
        labelLocale={buttonLabelText ? buttonLabelText : <FormattedMessage id="periodAdmin.changePeriodStateLabel"/>}
      />
    </div>
  );
};

export default ChangePeriodStateButton;



// WEBPACK FOOTER //
// ./source/client/components/periodAdmin/changePeriodStateButton.jsx